import { RESTING_DOM_CHARS, valueCaretOffsets } from '../utils/nestedHtml';
import { placeCaretAtOffset } from '../utils/placeFieldCaret';

/** Focus expands a long value. Blur commits it and collapses the preview. */
export function useNestedFieldFocus({
  elRef,
  readOnly,
  onFocus,
  focusedRef,
  allSelectedRef,
  lastCommittedRef,
  paint,
  commit,
  clearAllSelected,
  pickerOpenRef,
  mathMenuOpenRef,
  slashOpenRef,
  openMathOnPill,
}) {
  const handleFocus = () => {
    focusedRef.current = true;
    onFocus?.();
    const full = lastCommittedRef.current || '';
    if (full.length <= RESTING_DOM_CHARS) return;
    const el = elRef.current;
    const offset = valueCaretOffsets(el).start;
    paint(full);
    placeCaretAtOffset(el, offset);
  };

  const handlePointerDown = (e) => {
    if (allSelectedRef.current) clearAllSelected();
    if (readOnly || e.button !== 0) return;
    const pill = e.target.closest?.('[data-doc-math]');
    if (!pill || !elRef.current?.contains(pill) || pill.closest('.doc-math-menu')) return;
    e.preventDefault();
    e.stopPropagation();
    openMathOnPill(pill);
  };

  const handleBlur = () => {
    if (pickerOpenRef.current || mathMenuOpenRef.current || slashOpenRef.current) return;
    clearAllSelected();
    focusedRef.current = false;
    commit();
    // Collapse back to the short preview now that the full value is stored.
    if ((lastCommittedRef.current || '').length > RESTING_DOM_CHARS) {
      paint(lastCommittedRef.current);
    }
  };

  return { handleFocus, handlePointerDown, handleBlur };
}
